import React from 'react';

import CentralStaticInfo from '@app/components/Pages/Resources/VetResources/CentralStaticInfo/CentralStaticInfo';
import { MastHeadText, MastHeadTitle, sliderItems } from '@app/components/Pages/Resources/VetResources/VetResourcesContent';
import Masthead from '@app/components/UI/MastHead/Masthead';
import SliderTes from '@app/components/UI/Slider/SliderTes';
import img from '@app/images/content/Finding-the-Meaning-in-Mourning1.png';
import imgMobile from '@app/images/content/mobile/Finding-the-Meaning-in-Mourning1.png';
import HelmetProvider from '@app/providers/HelmetProvider/HelmetProvider';

import '@app/scss/components/vetResourceCenter.scss';

const VetResourceCenter: React.FC = () => {
	const loginForm = React.useRef<HTMLDivElement | null>(null);
	const signupForm = React.useRef<HTMLDivElement | null>(null);

	const scrollToBlock = (ref: React.RefObject<HTMLDivElement>) => {
		ref?.current?.scrollIntoView();
	};

	return (
		<HelmetProvider>
			<div className="vet-res-center">
				<Masthead
					title={MastHeadTitle}
					imageSrc={img}
					mobileSrc={imgMobile}
					imageAlt="Senior black dogs"
					text={MastHeadText}
					buttonText={
						<div className="masthead-body-quote__login">
							<div className="masthead-body-quote__login-text">Sign up to access the Veterinary Resource Center!</div>
							<div className="masthead-body-quote__login-btn">
								<button type="button" className="btn btn-primary" onClick={() => scrollToBlock(signupForm)}>
									Sign Up
								</button>
								<button type="button" className="btn btn-primary" onClick={() => scrollToBlock(loginForm)}>
									Log In
								</button>
							</div>
						</div>
					}
				/>

				<CentralStaticInfo loginRef={loginForm} signupRef={signupForm} />

				<div className="vet-res-center__slider-wrapper">
					<div className="vet-res-center__slider">
						<SliderTes sliderTesItemContent={sliderItems} title="Clinic testimonials" location="" />
					</div>
				</div>
			</div>
		</HelmetProvider>
	);
};

export default VetResourceCenter;
